import type { svgPlaceType } from '../types'

import LogoBrandClient from './LogoBrand.client'
import LogoBrandServer from './LogoBrand.server'

type Props = {
  isDarkMode?: boolean
} & svgPlaceType

export default function LogoBrand({ isDarkMode, ...props }: Props) {
  return (
    <LogoBrandClient {...props}>
      <LogoBrandServer isDarkMode={isDarkMode} {...props} />
    </LogoBrandClient>
  )
}
